//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'



//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.one_game_category;
//  -- Examples array selector --------



export const useOneGameCategory = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}